import styles from './styles.module.scss'

export default function LoadingAnimation () {
  return <div className={styles.animation}></div>
}
